module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "title-no1"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('p', {
    staticClass: "in-para"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Title",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Dedication",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('a', {
    attrs: {
      "href": "#/Acknowledgments#Ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('a', {
    attrs: {
      "href": "#/Introduction#Intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("CHAPTER ONE")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Chapter1#C1"
    }
  }, [_vm._v("Superstars of Early Denton")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER TWO")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter2#C2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superstars of Business and Philanthropy")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER THREE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter3#C3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superstars of Public, Political, and Military Service")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FOUR")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter4#C4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superstars of the Arts")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER FIVE")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter5#C5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superstars of Education")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SIX")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter6#C6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superstars of Athletics")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER SEVEN")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter7#C7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superstars of Space, Medicine, Technology, and Innovation")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("CHAPTER EIGHT")]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/Chapter8#C8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Superstars as Community Spirits and Civic Heroes")])]), _vm._v(" "), _c('p', {
    staticClass: "in-para"
  }, [_c('span', {
    attrs: {
      "href": "#/Index#Ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bbd272c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 75
// module chunks = 0